import { Popover } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div<{
  active: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N200};
  height: 55px;
  background-color: ${(props) => props.active && 'rgba(80, 185, 155, 0.3)'};
`;

export const SelectableContent = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Spacing = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Tick = styled.img`
  height: 30px;
  margin-right: 20px;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => 4 * props.theme.spacing()}px;
  padding-top: 0px;
  font-size: 14px;
  ul {
    margin-block-start: 0px;
    padding-inline-start: ${(props) => props.theme.spacing() * 2}px;
  }
`;

export const DescriptionHeader = styled.div`
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid lightgrey;
  margin-left: -${(props) => 4 * props.theme.spacing()}px;
  margin-right: -${(props) => 4 * props.theme.spacing()}px;
`;

export const Name = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  justify-content: center;
  margin-left: 10%;
  h3 {
    color: ${(props) => props.theme.newPalette.neutral.N800};
    font-size: 15px;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 80%;
    margin-left: 20%;
  }
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 20%;
  }
`;

export const HelpButton = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const Pop = styled(Popover)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .MuiPopover-paper {
    position: initial;
    width: 40%;

    @media screen and (min-width: 0px) and (max-width: 480px) {
      width: 100%;
    }
  }
`;
